import React, { ChangeEvent } from 'react';
import { Tab, Tabs as MuiTabs } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ITabs } from './types';

export const Tabs = ({
    tabs,
    setCurrentTab,
    currentTab = 'all',
    setPage,
    ...props
}: ITabs) => {
    const { t } = useTranslation();

    const handleChange = (event: ChangeEvent<{}>, value: string) => {
        if (setCurrentTab) {
            setPage(0);
            setCurrentTab(value);
        }
    };

    return (
        <MuiTabs
            scrollButtons="auto"
            textColor="secondary"
            variant="scrollable"
            onChange={handleChange}
            value={currentTab}
            {...props}
        >
            <Tab value={'all'} label={t('Tabs.All')} />
            {tabs && tabs.map((item, key) => <Tab key={key} {...item} />)}
        </MuiTabs>
    );
};
